export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    value: {
      default: undefined
    },

    dropdown: {
      type: Boolean,
      default: false,
    },

    options: {
      type: Array,
      default: () => []
    },

    value2id: {
      type: Function,
      default: undefined
    },

    id2value: {
      type: Function,
      default: undefined
    },

    item2option: {
      type: Function,
      default: undefined
    },

    loading: {
      type: Boolean,
      default: false
    },
  }
};
